export default __webpack_public_path__ + "static/media/16_Icono_Agregar empresa.4a8f6963.svg";